import React from 'react';
import {
  Button,
  Modal,
  Overlay,
  Tooltip,
  DropdownButton,
  Dropdown,
  Table,
} from 'react-bootstrap';
import { useMapSinglewireSiteModal } from './useMapSinglewireSiteModal';
import './mapSinglewireSite.scss';

const MapSingleWireSiteModal = () => {
  const {
    showModel,
    handleClose,
    handleShow,
    showTooltip,
    setShowTooltip,
    tooltipRef,
    isTokenAdded,
    handleSelectGroup,
    assignments,
    setAssignments,
    availableGroups,
    sitesData,
    handleMapSinglewireSites
  } = useMapSinglewireSiteModal();

  return (
    <>
      <span
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        ref={tooltipRef}
      >
        {!isTokenAdded && (
          <Overlay
            target={tooltipRef.current}
            show={showTooltip}
            placement='top'
          >
            {(props) => (
              <Tooltip id='overlay-tooltip' {...props}>
                Add Token to map the sites.
              </Tooltip>
            )}
          </Overlay>
        )}
        <span className='singlewire-btn'>
          <Button disabled={!isTokenAdded} onClick={handleShow}>
            <span>Map Sites</span>
          </Button>
        </span>
      </span>

      <Modal
        show={showModel}
        onHide={handleClose}
        className='modal-container mapsite'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Map Sites to Groups</Modal.Title>
        </Modal.Header>
        <Modal.Body className='mapsite-body'>
          <Table striped bordered hover className='fixed-table'>
            <thead>
              <tr>
                <th>Singlewire Site</th>
                <th>FlashCast Group</th>
              </tr>
            </thead>
            <tbody>
              {sitesData?.map((site) => (
                <tr key={site.siteId}>
                  <td>{site.siteName}</td>
                  <td>
                    <DropdownButton
                      className='dropdown-button-fixed'
                      id={`dropdown-${site.siteId}`}
                      title={
                        assignments[site.siteId]
                          ? assignments[site.siteId]
                          : 'Select Group'
                      }
                      variant={'light'}
                    >
                      {availableGroups?.map((group) => (
                        <Dropdown.Item
                          key={group}
                          active={assignments[site.siteId] === group}
                          onClick={() => handleSelectGroup(site.siteId, group)}
                        >
                          {group}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn-style' type='submit' onClick={handleMapSinglewireSites}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MapSingleWireSiteModal;
